import React from 'react';
import { Row, Col, Modal, Button, Checkbox } from 'antd';
import TextField from '@mui/material/TextField';
import { _success, _setAxios, _getBase64, _beforeUploadImage, _getFile } from '../../../../lib/Helper';

import "./style.css"
import { noImage } from '../../../../data/image';
class FormContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,
        };
    }

    componentDidMount() {
        const coverImg = this.props.data.file ? this.props.data.main_path + this.props.data.file : noImage
        this.setState({
            values: this.props.data,
            fileList: this.props.data.file ? [{
                uid: '-1',
                name: 'image.png',
                status: 'done',
                url: coverImg,
            }] : [],
            previewImage: coverImg,
            previewTitle: this.props.data.judul,
        })
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    // FILE IMAGE UPLOAD START ---------------------------------------------------------------------------------------------------------------------------
    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await _getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            visible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    };

    handleChangeImage = ({ fileList }) => {
        if (this.state.validateImage === true) {
            fileList.forEach((row, i) => {
                fileList[i].status = "done"
            });
        }

        var foto = this.state.values.foto
        if (fileList.length > 0) {
            foto = fileList[0].thumbUrl
        }
        this.setState({
            fileList,
            values: {
                ...this.state.values,
                foto: foto
            },
        })
    };

    beforeUploadImage = (file) => {
        const validate = _beforeUploadImage(file)
        if (validate === false) {
            this.setState({ validateImage: false })
        } else {
            this.setState({ validateImage: true })
        }
        return true
    };

    handleSubmit = async () => {
        const { values } = this.state

        this.setState({
            loading: true
        });

        const params = {
            judul: values.judul ? values.judul : null,
            deskripsi: values.deskripsi ? values.deskripsi : null,
            file: await _getFile(this.state.fileList),
            kategori: "Pengumuman Penting",
            is_tampilkan: values.is_tampilkan && values.is_tampilkan.length > 0 ? values.is_tampilkan[0] : 0,
        }

        let endpoint = "kegiatan-sekolah"
        let method = "POST"
        if (values.id) {
            endpoint = "kegiatan-sekolah/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {

        const { values, errors } = this.state

        return (
            <Modal
                maskClosable={false}
                title={"Form pengumuman"}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                // width={1024}
                closable={false}
                footer={<>
                    <Button onClick={this.props.hideModal}>Batal</Button>
                    <Button type="primary" htmlType="submit" onClick={this.handleSubmit} loading={this.state.loading}>Simpan</Button>
                </>}
            >
                <Row gutter={[24, 24]}>
                    <Col xs={24} sm={24}>
                        <Row gutter={[24, 24]} >
                            <Col xs={24}>
                                <TextField
                                    fullWidth
                                    label="Judul *"
                                    size="small"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    name="judul"
                                    type="text"
                                    onChange={(e) => {
                                        this.handleChangeSetValue("judul", e.target.value)
                                    }}
                                    value={values.judul || null}
                                    error={this.hasError('judul')}
                                    helperText={
                                        this.hasError('judul') ? errors.judul[0] : null
                                    }
                                />
                            </Col>
                            <Col xs={24}>
                                <TextField
                                    multiline
                                    fullWidth
                                    label="Deskripsi *"
                                    // size="small"
                                    minRows={3}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    name="deskripsi"
                                    type="text"
                                    onChange={(e) => {
                                        this.handleChangeSetValue("deskripsi", e.target.value)
                                    }}
                                    value={values.deskripsi || ''}
                                    error={this.hasError('deskripsi')}
                                    helperText={
                                        this.hasError('deskripsi') ? errors.deskripsi[0] : null
                                    }
                                />
                            </Col>
                            <Col xs={24}>
                                <Checkbox.Group style={{ width: '100%' }}
                                    name="is_tampilkan"
                                    defaultValue={values.is_tampilkan}
                                    value={values.is_tampilkan}
                                    onChange={(newValue) => {
                                        this.handleChangeSetValue("is_tampilkan", newValue)
                                    }}>
                                    <Row gutter={[16, 16]}>
                                        <Col span={12}>
                                            <Checkbox
                                                value={"1"}
                                                checked
                                            // checked={values.is_tampilkan === 1 ? true : false}
                                            >Publikasikan</Checkbox>
                                        </Col>
                                    </Row>
                                </Checkbox.Group>
                            </Col>



                        </Row>
                    </Col>
                </Row>

            </Modal>
        )
    }
}

export default FormContent;
